var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimpleShiny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.dev/svgjs",
    width: 1440,
    height: 560,
    preserveAspectRatio: "none",
    viewBox: "0 0 1440 560",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(\"#SvgjsMask1026\")",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 560,
    x: 0,
    y: 0,
    fill: "rgba(156, 167, 247, 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,611.16C117.836,598.345,231.121,577.351,337.681,525.442C455.66,467.971,607.006,420.537,647.542,295.722C688.479,169.672,559.377,53.259,533.228,-76.667C509.151,-196.297,572.002,-334.829,500.703,-433.862C428.872,-533.634,286.617,-540.262,170.463,-580.543C47.895,-623.049,-74.914,-715.504,-198.602,-676.376C-322.234,-637.265,-367.779,-489.791,-445.21,-385.777C-516.319,-290.255,-604.59,-206.525,-634.23,-91.189C-665.837,31.803,-659.038,161.918,-616.728,281.65C-571.914,408.468,-507.06,541.022,-388.428,604.406C-271.851,666.692,-131.398,625.45,0,611.16",
    fill: "#8996f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 1194.99C1557.2 1208.713 1655.8899999999999 1114.19 1755.4940000000001 1050.9180000000001 1855.62 987.315 1978.0430000000001 935.9359999999999 2021.537 825.579 2064.665 716.1510000000001 2027.661 589.754 1979.55 482.424 1938.463 390.76300000000003 1846.686 339.74199999999996 1773.108 271.36 1708.382 211.20499999999998 1648.226 152.37900000000002 1573.567 105.11200000000002 1472.498 41.125 1372.316-94.298 1259.8319999999999-53.59699999999998 1144.684-11.932000000000016 1179.439 173.02300000000002 1109.019 273.203 1049.296 358.164 927.59 385.598 884.638 480.151 835.858 587.535 799.924 723.136 857.999 825.7909999999999 916.268 928.788 1068.739 918.815 1168.666 982.2049999999999 1267.731 1045.048 1323.48 1181.346 1440 1194.99",
    fill: "#afb8f9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "SvgjsMask1026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 560,
    fill: "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleShiny);
export default __webpack_public_path__ + "static/media/simple_shiny.7ae80f6b3beab82db953dfcddb0edea9.svg";
export { ForwardRef as ReactComponent };